exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flex-b3354090{display:flex;color:#757575;margin-bottom:15px}.iconCircle-77d2a933{height:50px;width:50px;border:2px solid #C8E6DC;border-radius:100%;display:flex;align-items:center;justify-content:center}.iconWrap-4bfbf719{margin-right:15px}.link-026212ab a,.link-026212ab a:focus,.link-026212ab a:hover,.link-026212ab a:active,.link-026212ab a:visited{font-size:13px;font-weight:500}.large-e71a215e{margin:100px 0 140px 0;text-align:center}.large-e71a215e .flex-b3354090{display:block}.large-e71a215e .iconCircle-77d2a933{margin:0 auto 20px auto;height:60px;width:60px;border-width:3px}.large-e71a215e .iconWrap-4bfbf719{margin-right:0}\n", ""]);

// Exports
exports.locals = {
	"flex": "flex-b3354090",
	"iconCircle": "iconCircle-77d2a933",
	"iconWrap": "iconWrap-4bfbf719",
	"link": "link-026212ab",
	"large": "large-e71a215e"
};